import { cva } from 'class-variance-authority';

/**
 * Warianty przycisku w osobnym pliku, zeby `Button.tsx` eksportowal wylacznie
 * komponent — tego wymaga poprawne dzialanie fast refresh.
 *
 * Wyeksportowane publicznie, bo ten sam wyglad nakladamy tez na `<a>`
 * i `<Link>` z routera bez duplikowania klas.
 */
export const buttonVariants = cva(
  [
    'inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap select-none',
    'font-semibold transition-colors duration-150',
    'disabled:pointer-events-none disabled:opacity-45',
  ],
  {
    variants: {
      variant: {
        /** Akcja glowna — zolty przycisk marki (np. „Zaloguj się”, „Zapisz przydział”). */
        primary: 'bg-brand text-fg-on-brand shadow-xs hover:bg-brand-hover active:bg-brand-active',
        /** Akcja drugorzedna — biala karta z obramowaniem (np. „Anuluj”, „Import CSV”). */
        secondary:
          'border border-border-strong bg-surface text-fg shadow-xs hover:bg-surface-hover active:bg-surface-sunken',
        /** Akcja poboczna, bez tla — np. ikonowe akcje w tabeli. */
        ghost: 'bg-transparent text-fg-muted hover:bg-surface-hover hover:text-fg',
        /** Akcja destrukcyjna. */
        danger: 'bg-danger-500 text-white shadow-xs hover:bg-danger-600',
        /** Wyroznienie w tonacji marki, lzejsze niz `primary`. */
        subtle: 'bg-brand-subtle text-brand-text hover:bg-brand-200 hover:text-brand-900',
      },
      size: {
        sm: 'h-9 rounded-md px-3 text-[0.8125rem]',
        md: 'h-11 rounded-lg px-4 text-sm',
        lg: 'h-13 rounded-lg px-6 text-[0.9375rem]',
      },
      fullWidth: {
        true: 'w-full',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
);
